import { default as MuiSkeleton } from "@mui/material/Skeleton"
import { styled } from "@mui/material/styles"

export const ChipSkeleton = styled(MuiSkeleton)(({ theme }) => ({
    width: "30%",
    height: theme.components.chip.defaultHeight,
    borderRadius: "16px",
}))